import React from "react";
import { useGetTableData2 } from "../Plan/tableHooks";
import { formatDateString, getPresetInfo } from "./utils";
import { Button } from "@mui/material";
import { Icon } from "../../../components/icons";
import DateScheduleEditor from "./DateScheduleEditor";
import * as S from "./styles";
import { dayTypeMappingForSide } from "./constants";

function SidebarContent({
  selectedDate,
  calendarData,
  presets,
  isDateEditorOpen,
  setIsDateEditorOpen,
  handleMachineClick,
  setDayModalOpen,
  handleDaySettingClick,
  openSnackbar,
  group_code,
  project_code,
}) {
  const dateString = formatDateString(selectedDate);
  const dateData = calendarData?.data?.specTimeData?.filter(
    (item) => item.oper_date === dateString
  )[0];
  const machineSchedules =
    calendarData?.data?.machineTimeData?.filter(
      (item) => item.oper_date === dateString
    ) || [];
  const { operDayTime } = useGetTableData2(
    true,
    `/api/factory/getDayM?group_code=${group_code}&project_code=${project_code}`,
    "operDayTime"
  );
  const selectedDayType = selectedDate?.getDay();
  const currentDaySchedule = operDayTime?.find((schedule) => {
    const validFrom = new Date(schedule.valid_from).toISOString().split("T")[0];
    const validTo = new Date(schedule.valid_to).toISOString().split("T")[0];
    const selectedDateStr = selectedDate.toISOString().split("T")[0];
    return selectedDateStr >= validFrom && selectedDateStr <= validTo;
  });
  const dayTypeId =
    currentDaySchedule?.[dayTypeMappingForSide[selectedDayType]];
  const dayPreset = presets?.find((p) => p.id === dayTypeId);
  return (
    <>
      <S.SectionTitle>
        <h3>요일 정보</h3>
        <Button
          startIcon={
            <Icon
              name="settingsIcon"
              style={{ width: "16px", height: "16px" }}
            />
          }
          // onClick={() => setDayModalOpen(true)}
          onClick={handleDaySettingClick}
          size="small"
        >
          설정
        </Button>
      </S.SectionTitle>
      {dayTypeId !== undefined ? (
        <S.DayInfo>
          {dayTypeId === -1 ? (
            <S.DateInfo $isHoliday={true}>
              <S.MachineTitle>휴일</S.MachineTitle>
            </S.DateInfo>
          ) : (
            dayPreset && (
              <>
                <S.MachineTitle>{dayPreset.name}</S.MachineTitle>
                {dayPreset.schedules && (
                  <S.TimeSlots>
                    {dayPreset.schedules.map((schedule, idx) => (
                      <S.TimeSlot key={`day-schedule-${idx}`}>
                        <S.TimeDisplay>
                          {`${schedule.start.trim()} ~ ${schedule.end.trim()}`}
                        </S.TimeDisplay>
                      </S.TimeSlot>
                    ))}
                  </S.TimeSlots>
                )}
              </>
            )
          )}
        </S.DayInfo>
      ) : (
        <S.ActionButton
          variant="outlined"
          startIcon={
            <Icon
              name="calendarIcon"
              style={{ width: "16px", height: "16px" }}
            />
          }
          // onClick={() => setDayModalOpen(true)}
          onClick={handleDaySettingClick}
        >
          요일별 가동시간 설정
        </S.ActionButton>
      )}
      <S.SectionTitle style={{ marginTop: "2rem" }}>
        <h3>일정</h3>
        {dateData && (
          <Button
            startIcon={
              dateData ? (
                <Icon
                  name="settingsIcon"
                  style={{ width: "16px", height: "16px" }}
                />
              ) : (
                <Icon
                  name="plusIcon"
                  style={{ width: "16px", height: "16px" }}
                />
              )
            }
            onClick={() => setIsDateEditorOpen(true)}
            size="small"
          >
            수정
          </Button>
        )}
      </S.SectionTitle>
      {isDateEditorOpen ? (
        <DateScheduleEditor
          date={dateString}
          presets={presets}
          onComplete={() => setIsDateEditorOpen(false)}
          initialData={{
            isHoliday: dateData?.type_id === -1,
            typeId: dateData?.type_id,
            description: dateData?.description || "",
          }}
          openSnackbar={openSnackbar}
          group_code={group_code}
          project_code={project_code}
        />
      ) : dateData ? (
        <S.DateInfo $isHoliday={dateData.type_id === -1}>
          <S.MachineTitle>
            {dateData.type_id === -1
              ? "휴일"
              : getPresetInfo(dateData.type_id, presets)?.name}
          </S.MachineTitle>
          <S.PresetInfo>{dateData.description}</S.PresetInfo>
          {dateData.type_id !== -1 && (
            <S.TimeSlots>
              {getPresetInfo(dateData.type_id, presets)?.schedules.map(
                (schedule, sIdx) => (
                  <S.TimeSlot key={`date-schedule-${sIdx}`} $isHoliday={false}>
                    <S.TimeDisplay>
                      {`${schedule.start.trim()} ~ ${schedule.end.trim()}`}
                    </S.TimeDisplay>
                  </S.TimeSlot>
                )
              )}
            </S.TimeSlots>
          )}
        </S.DateInfo>
      ) : (
        <S.ActionButton
          variant="outlined"
          startIcon={
            <Icon
              name="calendarIcon"
              style={{ width: "16px", height: "16px" }}
            />
          }
          onClick={() => setIsDateEditorOpen(true)}
        >
          날짜별 근무시간 수정
        </S.ActionButton>
      )}
      <S.SectionTitle style={{ marginTop: "2rem" }}>
        <h3>
          장비 일정&nbsp;
          {machineSchedules.length > 0 && `(${machineSchedules.length})`}
        </h3>
        {machineSchedules.length > 0 && (
          <Button
            startIcon={
              <Icon name="plusIcon" style={{ width: "16px", height: "16px" }} />
            }
            onClick={handleMachineClick}
            size="small"
          >
            관리
          </Button>
        )}
      </S.SectionTitle>
      {machineSchedules.length > 0 ? (
        machineSchedules.map((machine, idx) => (
          <S.InfoCard key={`machine-${idx}`}>
            <S.MachineTitle>{machine.machine_name}</S.MachineTitle>
            <S.PresetInfo>
              {getPresetInfo(machine.type_id, presets)?.name || "프리셋 없음"}
            </S.PresetInfo>
            {getPresetInfo(machine.type_id, presets)?.schedules && (
              <S.TimeSlots>
                {getPresetInfo(machine.type_id, presets).schedules.map(
                  (schedule, sIdx) => (
                    <S.TimeSlot key={`schedule-${sIdx}`}>
                      <S.TimeDisplay>
                        {`${schedule.start.trim()} ~ ${schedule.end.trim()}`}
                      </S.TimeDisplay>
                    </S.TimeSlot>
                  )
                )}
              </S.TimeSlots>
            )}
          </S.InfoCard>
        ))
      ) : (
        <S.ActionButton
          variant="outlined"
          startIcon={
            <Icon
              name="buildingIcon"
              style={{ width: "16px", height: "16px" }}
            />
          }
          onClick={handleMachineClick}
        >
          설비 가동시간 등록으로 이동
        </S.ActionButton>
      )}
    </>
  );
}

export default SidebarContent;
